import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import App from "./App";
import {store}  from "./store";
import './index.css'; // Add this line

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

root.render(
  <Provider store={store}>
    <App />
  </Provider>
);
